import styled from "styled-components";

const HelpButtonStyle = styled.button`
  background: none;
  border: none;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  &:focus {
    outline: none;
  }
`;

export default HelpButtonStyle;
